import Cookies from 'js-cookie';
import UserAuthService from '@Helpers/URLHelpers/UserAuthService';

class KzqTicketRegistryViewService {

    constructor() {
        var originalFetch = require('isomorphic-fetch');
        this.fetch = require('fetch-retry')(originalFetch);
        this.BASE = '/api/kzq-ticket-registry';
        this.GET_LIST_FILTERED = '/list/filtered';
        this.EXPORT = '/export';
        this.EXPORT_PDF = '/export/pdf';
    }

    async getListFiltered(filterMap) {
        let csrfToken = Cookies.get('XSRF-TOKEN');
        let url = window.location.origin + this.BASE + this.GET_LIST_FILTERED;
        try {
            return this.fetch(url, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'X-XSRF-TOKEN': csrfToken
                },
                body: JSON.stringify(filterMap)
            }).then(data => data.json())
              .then(data => {
                  if (data.error !== undefined) {
                      if (data.error === 'Session Expired') {
                          new UserAuthService().logout();
                      } else {
                          localStorage.setItem('errorUUID', data.uuid);
                      }
                  }
                  return data;
              });
        } catch (err) {
            console.log(err);
        }
    }
    async export(filterMap) {
        let csrfToken = Cookies.get('XSRF-TOKEN');
        let url = window.location.origin + this.BASE + this.EXPORT;
        try {
            return this.fetch(url, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'X-XSRF-TOKEN': csrfToken
                },
                body: JSON.stringify(filterMap)
            }).then(data => data.json())
              .then(data => {
                  if (data.error !== undefined) {
                      if (data.error === 'Session Expired') {
                          new UserAuthService().logout();
                      } else {
                          localStorage.setItem('errorUUID', data.uuid);
                      }
                  }
                  return data;
              });
        } catch (err) {
            console.log(err);
        }
    }
    async exportPdf(filterMap) {
        let csrfToken = Cookies.get('XSRF-TOKEN');
        let url = window.location.origin + this.BASE + this.EXPORT_PDF;
        try {
            return this.fetch(url, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'X-XSRF-TOKEN': csrfToken
                },
                body: JSON.stringify(filterMap)
            }).then(data => data.json())
              .then(data => {
                  if (data.error !== undefined) {
                      if (data.error === 'Session Expired') {
                          new UserAuthService().logout();
                      } else {
                          localStorage.setItem('errorUUID', data.uuid);
                      }
                  }
                  return data;
              });
        } catch (err) {
            console.log(err);
        }
    }
}

export default KzqTicketRegistryViewService;
